import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import './FormInput.scss';

const FormInput = ({
  input,
  label,
  meta: {
    touched,
    error,
  },
  min,
  placeholder,
  step,
  type,
}) => (
  <div className="form-input">
    <FormControl
      fullWidth
      error={Boolean(touched && error)}
    >
      <InputLabel>{label}</InputLabel>
      <Input
        {...input}
        placeholder={placeholder}
        type={type}
        inputProps={{
          min,
          step,
        }}
      />
      {(touched && error) && (
        <FormHelperText>{error}</FormHelperText>
      )}
    </FormControl>
  </div>
);

FormInput.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
    ]),
  }),
  min: PropTypes.string,
  placeholder: PropTypes.string,
  step: PropTypes.string,
  type: PropTypes.string,
};

FormInput.defaultProps = {
  input: {},
  label: '',
  meta: {
    touched: false,
    error: [],
  },
  min: '',
  placeholder: '',
  step: '',
  type: '',
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/common/components/FormInput/FormInput.js